import React, { useState } from "react";
import NavbarSave from "../components/navbar-save";
import Footer from "../components/footer";
import {
  EnvelopeFill,
  TelephoneFill,
  GeoAltFill,
  Globe2,
} from "react-bootstrap-icons";

const title = "Contact Us";
const ContactUs = () => {
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowSuccess(true);
  };

  return (
    <>
      <NavbarSave />
      <div
        className="bg-white w-100 h-100 overflow-y-auto"
        style={{ paddingTop: 156 }}
      >
        <div className="container">
          <div className="fs-1 fw-bold">{title}</div>
          <p className="mb-5">Last updated: {new Date().getFullYear()}</p>
          <div className="text-left">
            <p className="fs-5">
              For any questions or concerns, please contact us at{" "}
            </p>
            <ContactUsText2 />
            {showSuccess ? (
              <ContactUsSucess />
            ) : (
              <ContactUsText
                setShowSuccess={setShowSuccess}
                handleSubmit={handleSubmit}
              />
            )}
          </div>
          <div className="py-5" />
          <div className="py-5" />
        </div>
        <Footer />
      </div>
    </>
  );
};

export { ContactUs, ContactUsText2 };

function ContactUsText({ handleSubmit }) {
  return (
    <div className="mt-5 w-50 w-lg-50 w-sm-100">
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="name" className="form-label">
            Name
          </label>
          <input type="text" className="form-control" id="name" />
        </div>
        <div className="mb-4">
          <label htmlFor="email" className="form-label">
            Email address
          </label>
          <input type="email" className="form-control" id="email" />
        </div>
        <div className="mb-4">
          <label htmlFor="message" className="form-label">
            Message
          </label>
          <textarea className="form-control" id="message" rows="3"></textarea>
        </div>
        <button
          type="submit"
          className="btn btn-primary px-5 py-2 mt-4 fs-5 rounded-3"
        >
          Send
        </button>
      </form>
    </div>
  );
}

function ContactUsSucess() {
  return (
    <>
      <div className="mt-5 w-50 w-lg-50 w-sm-100 fade-in-success">
        <div className="d-flex justify-content-center align-items-center mt-3">
          <i
            class="bi bi-check-circle-fill"
            style={{ fontSize: 200, color: "#00a73d" }}
          ></i>
        </div>
        <p className="fs-5 fw-semibold text-center mb-5">
          Your message has been sent successfully.
        </p>
      </div>

      <style jsx>
        {`
          .fade-in-success {
            animation: fadeIn 0.3s forwards ease-in;
            opacity: 0;
          }
        `}
      </style>
    </>
  );
}

function ContactUsText2() {
  return (
    <div className="fs-6">
      <div className="d-flex align-items-start mb-3">
        <EnvelopeFill className="me-3 text-primary fs-4 mt-1" />
        <div>
          <strong>
            <a
              href="mailto:savesecurities7@gmail.com"
              className="text-decoration-none text-dark"
            >
              savesecurities7@gmail.com
            </a>
          </strong>
        </div>
      </div>

      <div className="d-flex align-items-start mb-3">
        <TelephoneFill className="me-3 text-primary fs-4 mt-1" />
        <div>
          <strong>+91-91473-80653</strong>
        </div>
      </div>

      <div className="d-flex align-items-start mb-3">
        <GeoAltFill className="me-3 text-primary fs-4 mt-1" />
        <div>
          <strong>
            Primarc Tower, DN - 36, 
            <br />
            11th Floor, College More, 
            <br />
            Kolkata - 700091
          </strong>
        </div>
      </div>

      <div className="d-flex align-items-start">
        <Globe2 className="me-3 text-primary fs-4 mt-1" />
        <div>
          <strong>
            <a
              href="https://www.vulnerabilityassessmenttool.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none text-dark"
            >
              www.vulnerabilityassessmenttool.com
            </a>
          </strong>
        </div>
      </div>
    </div>
  );
}
